import spriteSvg from '@/assets/img/sprite.svg';

type Props = {
  className?: string;
  name: string;
};

export const SpriteSvg = (props: Props) => {
  return (
    <svg className={props.className || 'i'}>
      <use xlinkHref={`${spriteSvg}#${props.name}`} />
    </svg>
  );
};
